import { useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setStoresFilter } from '../../Redux/Slices/Stores';
import { Map, Placemark, FullscreenControl, ZoomControl, Button } from '@pbe/react-yandex-maps';
import MapDoteOrange from '../../Assets/icons/MapDote-orange.svg';
import Fullscreen from '../../Assets/icons/fullscreen.svg'
import MapDoteGreen from '../../Assets/icons/MapDote-green.svg';
import MapDoteRed from '../../Assets/icons/MapDote-red.svg';
import MapDefaultDote from '../../Assets/icons/MapDefaultDote.svg';
import MapModal from './MapModal'
import Location from '../../Assets/icons/location.svg';
import { useRef } from 'react';

export default function CMap({valueFilter, valueSelect}) {
    const user = useSelector(state => state.user.user)
    const location = useSelector(state => state.user.location)
    const stores = useSelector(state => state.stores.stores)
    const cables = useSelector(state => state.cables.cables)
    const filterStores = useSelector(state => state.stores.storesFilter);
    const [placemarkState, setPlacemarkState] = useState('default')
    const [store, setStore] = useState(null)
    const mapRef = useRef(null);
    const dispatch = useDispatch()    

    useEffect(() => {
        const location = document.querySelector(`.ymaps-2-1-79-float-button`)
        if(!location) return
        location.classList.add('location')
    }, [filterStores])

    useEffect(() => {
        if(!valueSelect.length > 0 && !valueFilter.id) {
            setPlacemarkState('default')
            dispatch(setStoresFilter(stores))
        } else if (valueSelect.length > 0 && !valueFilter.id) { 
            setPlacemarkState('dote')
            dispatch(setStoresFilter(stores.filter(item => valueSelect.some(elem => item.vendor_id.includes(elem.id)))))
        } else if (!valueSelect.length > 0 && valueFilter.id) { 

            setPlacemarkState('dote')
            dispatch(setStoresFilter(stores.filter(store => {
                return cables.some(cable => store.marketplace_id === cable.marketplace_id)
             } )))
        } else if (valueSelect.length > 0 && valueFilter.id) {
            setPlacemarkState('price')
            dispatch(setStoresFilter(stores.filter(store => {
                return cables.some(cable => store.marketplace_id === cable.marketplace_id)
             } )))
        }
    }, [valueSelect.length, valueFilter.id, stores, cables])

    useEffect(() => {
        if(!mapRef.current) return
        mapRef.current.panTo(location.location, { duration: 500, padding: [50, 50, 50, 50]})
        setTimeout(()=> {
            mapRef.current.setZoom(9)
        }, 1000)
        
    }, [location, mapRef]);
    
    useEffect(() => {
        console.log(filterStores);
        
        if(!mapRef.current) return
        if(filterStores.length === 0) {
            mapRef.current.panTo(location.location, { duration: 0, padding: [50, 50, 50, 50], ZoomControl: false, checkZoomRange: false })
            return
        }
        if (placemarkState === 'price') {  
            const stores = filterStores.filter(item => {
                const obj = cables.find(metals => metals.marketplace_id === item.marketplace_id)   
                return obj
            }).map(item => item.coord).reduce(
                (acc, coord) => {
                    acc[0][0] = Math.min(acc[0][0], coord[0]); // юго-западный угол
                    acc[0][1] = Math.min(acc[0][1], coord[1]);
                    acc[1][0] = Math.max(acc[1][0], coord[0]); // северо-восточный угол
                    acc[1][1] = Math.max(acc[1][1], coord[1]);
                    return acc;
                },
                [[90, 180], [-90, -180]] // начальные значения для границ
            );
         
            
            if(stores.length > 0) {
                mapRef.current.setBounds(stores, { 
                    checkZoomRange: false,
                    duration: 500,
                    padding: [50, 50, 50, 50]
                });
                return
            }
        } else if (placemarkState === 'dote' || placemarkState === 'default') {  
            if(filterStores.length > 1){
                const stores = filterStores.map(item => item.coord).reduce(
                    (acc, coord) => {
                      acc[0][0] = Math.min(acc[0][0], coord[0]); // юго-западный угол
                      acc[0][1] = Math.min(acc[0][1], coord[1]);
                      acc[1][0] = Math.max(acc[1][0], coord[0]); // северо-восточный угол
                      acc[1][1] = Math.max(acc[1][1], coord[1]);
                      return acc;
                    },
                    [[90, 180], [-90, -180]] // начальные значения для границ
                );
                if(stores.length > 0) {
                    mapRef.current.setBounds(stores, { 
                        checkZoomRange: false,
                        duration: placemarkState === 'default' ? 500 : 500,
                        padding: [20, 20, 20, 20]
                    });
                }

            } else if(filterStores.length === 1) {
                const store = filterStores[0]          
                console.log(store);
                
                mapRef.current.panTo([Number(store.coord[0]), Number(store.coord[1])], { duration: 0, padding: [50, 50, 50, 50], zoom: 9, })
                setTimeout(()=> {
                    mapRef.current.setZoom(9)
                }, 600)
            
            }
        }
    }, [filterStores, placemarkState]); 

    function handleClick(item) {
        mapRef.current.panTo(item.coord, { duration: 500, padding: [0],  })
        setTimeout(()=> {
            mapRef.current.setZoom(14)
        }, 1000)
        
        setStore(item)
    }
    
    function handleClickLocation () {
        mapRef.current.panTo(location.location, { duration: 500, padding: [50, 50, 50, 50] })
        setTimeout(()=> {
            mapRef.current.setZoom(9)
        }, 1000)
    }
    
    return <>
        <Map instanceRef={mapRef} style={{ width: '100%', height: '100%' }} defaultState={{ center: location.location, zoom: 9 }} options={{autoFitToViewport: 'always', minZoom: 3, maxZoom: 13}} >
            <FullscreenControl options={{ position: { right: 10, top: 10 } }} data={{image: Fullscreen }} />
            <ZoomControl options={{ position: { right: 10, top: 100 } , size: 'small'}} />
            <Button instanceRef={(inst) =>inst?.events?.add('click', () => handleClickLocation())} data={{image: Location }} options={{selectOnClick: false, position: { right: 10, bottom: 10 }}} ></Button>
            {placemarkState === 'default' && filterStores.map((item, index) => 
                <Placemark key={index} geometry={[item.coord[0], item.coord[1]]}
                options={{ 
                    iconLayout: 'default#image',
                    iconColor: 'black',
                    iconImageHref: MapDefaultDote,
                    iconImageSize: [22, 22],
                    iconOffset: [0, 25],
                }}
                onClick={() => handleClick(item)}
            />)}
            {placemarkState === 'dote' && filterStores.map((item, index) => {
                return <Placemark key={index} geometry={[item.coord[0], item.coord[1]]} 
                    properties={{iconCaption: `${item.marketplace_name}`}}
                    options={{
                        preset: 'islands#blueCircleDotIconWithCaption',
                        iconColor: 'black',
                    }}
                    onClick={() => handleClick(item)}
                />
            })}
            {placemarkState === 'price' && filterStores.map((item, index) => {
                const obj = cables.find(cable => cable.marketplace_id === item.marketplace_id)
                console.log(obj);
                
                if(!obj?.price) return null
                return <Placemark  key={index} geometry={[item.coord[0], item.coord[1]]}
                properties={{ iconContent: `<div class="my-class"><p> ${Math.round(obj.price)} </p> </div>`, }}
                options={{
                    iconLayout: "default#imageWithContent",
                    iconImageHref: obj.price_correction === 0 ? MapDoteOrange : obj.price_correction > 0 ? MapDoteGreen : MapDoteRed,
                    zIndex: obj.price_correction === 0 ? 1 : obj.price_correction > 0 ? 2 : 3,
                    iconImageSize: [52, 60],
                    iconOffset: [-25, -16],
                }}
                
                modules={['layout.ImageWithContent']}
                onClick={(e) => handleClick({...item, ...obj}) }
            /> 
            })}
        </Map>
        {store && <MapModal item={store} setStore={setStore} />}
    </> 
}